import { IMPORT_SERVICES_PATH } from '@app/constants';
import type { NUtils } from '@app/types';

export const importClientServices: NUtils.ImportClientServices = async ({
  event,
  setFile,
  setExtension,
  navigate,
}) => {
  const file = event.target.files && event.target.files[0];
  const filename = file?.name || '';
  const extension = filename.split('.').pop() || '';

  if (file) {
    try {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      const result = await new Promise((resolve, reject) => {
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });

      if (typeof result === 'string') {
        const base64String = result.replace('data:', '').replace(/^.+,/, '');

        setFile(base64String);
        setExtension(extension);
        navigate(IMPORT_SERVICES_PATH);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error reading file:', error);
    }
  }
};
